import useSWR from 'swr'
import axios from 'axios'
import { BroadcastChannel } from 'broadcast-channel'
import { useState, useEffect } from 'react'
import { message } from 'antd'

export default function useUser() {
    const [onBoardingFormFilled, setOnBoardingFormFilled] = useState(true)
    let channel = new BroadcastChannel('logout')
    // const hasCookie = document.cookie.includes('auth_token=')
    const hasCookie = localStorage.getItem('FE_USER_DATA')
    const {data: user, mutate} = useSWR('/api/user/info')

    // const [user, setUser] = useState(JSON.parse(localStorage.getItem('FE_USER_DATA')));

    // const fetchUserInfo = async () => {
    //     try {
    //         const response = await axios.get('/api/user/info');
    //         console.log("response.data :- ",response.data);
    //         localStorage.setItem('FE_USER_DATA',JSON.stringify(response.data))
    //         setUser(response.data);
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };

    // console.log("user -- 1");
    // console.log(user);
    

    // const mutate = async (newData) => {
    //     if (newData) {
    //     setUser(newData); // Optimistically update the data
    //     }
    //     // await fetchUserInfo(); // Re-fetch from the server
    // };

    // useEffect(() => {
    //     user&&localStorage.getItem('fe_token')&&fetchUserInfo();
    //     return () => {}
    // }, []);

    const logout = async () => {
        axios({
            method: 'get',
            url:'/api/users/logout',
        })
        .then(res => {console.log("Logout response :- ",res?.data.message); })
        .catch(err => { console.log("Logout response error :- ",err?.response?.data?.error || err); })

        channel.postMessage('logout')
        localStorage.clear();
        document.cookie = "fe_access_token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
        document.cookie = "VA_JWT_Token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
        window.location.reload(true)
        mutate({}, false)
    }

    const logoutAllTabsEventListener = () => {
        channel.onmessage = () => {
            logout()
            channel.close()
        }
    }

    useEffect(() => {user && setOnBoardingFormFilled(!!user["onboarding_form"]);return () => {}}, [user])

    return {
        isLoggedIn: hasCookie,
        isAdmin: !!user?.admin,
        user,
        logout,
        login: mutate,
        logoutAllTabsEventListener,
        onBoardingFormFilled,
        setOnBoardingFormFilled,
    }
}